// extracted by mini-css-extract-plugin
module.exports = {"container":"PromotersPage_container__Etymf"};